<template>
  <div class="sidebar-right">
    <div class="buttons">
      <div
        class="sidebar-right-button"
        @click="newFile()"
        v-tooltip.bottom="'New File'"
      >
        <ph-file-plus />
      </div>
      <div
        class="sidebar-right-button"
        @click="clearWholeFile()"
        v-tooltip.bottom="'Clear All'"
      >
        <ph-trash-simple />
      </div>

      <div
        class="sidebar-right-button"
        @click="changeCodeLanguage('markdown')"
        v-tooltip.bottom="'Switch to Markdown code'"
      >
        <ph-text-aa />
      </div>

      <div
        class="sidebar-right-button"
        @click="changeCodeLanguage('xml')"
        v-tooltip.bottom="'Switch to HTML code'"
      >
        <ph-code />
      </div>
      <!-- <div
        class="sidebar-right-button"
        @click="changeCodeLanguage('xml')"
        v-tooltip.bottom="'Help'"
      >
        <ph-question />
      </div> -->
    </div>
    <div class="sidebar-right-button-text" @click="toggleTheme">
      {{ themeSwitch }}
    </div>
    <code-container :name="languageName" :language="language" :code="code" />
    <p class="copyright">
      Made with ❤️
      <a href="https://www.issamelnasiri.com/" style="color: white"
        >Issam El Nasiri</a
      >
    </p>
  </div>
</template>

<script>
import CodeContainer from "./CodeContainer.vue";
import { mapActions, mapGetters } from "vuex";
import { POSITION } from "vue-toastification";

import {
  PhTextAa,
  PhCode,
  // PhQuestion,
  PhFilePlus,
  PhTrashSimple,
} from "phosphor-vue";
export default {
  name: "SideBarRight",
  components: {
    CodeContainer,
    PhTextAa,
    PhCode,
    // PhQuestion,
    PhFilePlus,
    PhTrashSimple,
  },
  provide: {
    color: "white",
    size: 22,
    weight: "light",
    mirrored: false,
  },
  data() {
    return {
      language: "markdown",
      languageName: "markdown",
    };
  },
  methods: {
    changeCodeLanguage(language) {
      if (language === "xml") this.languageName = "html";
      else this.languageName = language;

      this.language = language;
    },
    newFile() {
      this.$modal.show("dialog", {
        title: "Are you sure you want to start with a new File?",
        text: "",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Yes",
            handler: () => {
              this.clearAll();
              this.$modal.hide("dialog");
              this.$toast.success("Started a new File!", {
                position: POSITION.BOTTOM_CENTER,
              });
            },
          },
        ],
      });
    },
    clearWholeFile() {
      this.$modal.show("dialog", {
        title: "Are you sure you want to clear the whole file?",
        text: "",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Clear File",
            handler: () => {
              this.clearAll();
              this.$modal.hide("dialog");
              this.$toast.error("Cleared All The Elements!", {
                position: POSITION.BOTTOM_CENTER,
              });
            },
          },
        ],
      });
    },
    ...mapActions(["toggleTheme", "clearAll"]),
  },

  computed: {
    themeSwitch() {
      return `Switch to ${
        this.theme == "standard" ? "Github" : "Standard"
      } theme`;
    },
    ...mapGetters(["code", "theme"]),
  },
};
</script>

<style lang="scss" scoped>
.sidebar-right {
  width: 23em;
  background-color: #494647;
  height: 100%;
  padding: 1rem 1rem;
  flex-shrink: 0;
}

.buttons {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1.5rem;
  & > :first-child {
    margin: 0.3rem;
  }
}

.sidebar-right-button {
  width: 43px;
  border: 0;
  cursor: pointer;
  height: 2.675rem;
  border-radius: 30px;
  font-size: 1rem;
  letter-spacing: 0.2px;
  min-height: 2.188em;
  min-width: 2.188em;
  margin-bottom: 0.626em;
  padding: 0.3em;
  margin: 0.3rem;
  color: white;
  background: #343233;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  &:hover {
    background: lighten(#343233, 15%);
  }
}

.sidebar-right-button-text {
  border: 0;
  cursor: pointer;
  height: 2.675rem;
  border-radius: 30px;
  font-size: 1rem;
  letter-spacing: 0.2px;
  min-height: 2.188em;
  min-width: 2.188em;
  margin-bottom: 0.626em;
  padding: 0.3em;
  margin: 0.3rem;
  color: white;
  font-family: "Rubik";
  background: #343233;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  &:hover {
    background: lighten(#343233, 15%);
  }
}

.copyright {
  font-family: "Rubik";
  font-weight: 600;
  font-size: 0.7rem;
  color: white;
  position: absolute;
  bottom: 0.3rem;
  right: 0.3rem;
  text-align: center;
  z-index: 3;
}
</style>
